export default function LoadingScreen({ isFullScreen = false }) {
    return (
        <div className={`${isFullScreen ? "app" : "page"}-loading`}>
            <div className="icon">
                <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            </div>
        </div>
    );
}